import * as React from 'react';
import Styled from 'styled-components';

import SVGIcon, { VALID_ICONS } from '../../Icon/SVGIcon';

export const SubNavSpan = Styled.span`
  text-align: right;
  height: 1.5em;
`;

interface ISubNavButtonProps {
  active?: boolean;
}

export const SubNavButtonContain = Styled.li`
  flex: 1 0 auto;
  padding-right: 0;

  svg {
    display: flex;
    height: 1.5em;
    width: 1.5em;
    margin: 0 0.5em 0 0;
  }

  span {
    display: flex;
  }
`;

export const SubNavButton =
 Styled.button<ISubNavButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme: { header }, active }) => active ? header.colorSubNavLinkHover : header.colorSubNavLink};
  border-bottom: 2px solid ${({ theme: { header }, active }) => active ? header.colorSubNavLinkHover : 'transparent'};
  border-top: 2px solid transparent;
  white-space: nowrap;
  height: 100%;
  width: 100%;

  svg {
    fill: ${({ theme: { header }, active }) => active ? header.colorSubNavLinkHover : header.colorSubNavLink};
  }

  &:hover,
  &:active,
  &:focus {
    color: ${({ theme: { header } }) => header.colorSubNavLinkHover};
    border-bottom: 2px solid ${({ theme: { header } }) => header.colorSubNavLinkHover};

    svg {
      fill: ${({ theme: { header } }) => header.colorSubNavLinkHover};
    }
  }
`;

export interface ISubNavLinkOptions {
  icon: VALID_ICONS;
  theme?: 'brand' | 'grey';
  active?: boolean;
}

export interface ISubNavLinkProps
  extends ISubNavLinkOptions,
    React.ButtonHTMLAttributes<HTMLButtonElement> {}

export class SubNavLink extends React.PureComponent<ISubNavLinkProps> {
  public render () {
    const { icon, theme, name, ...rest } = this.props;

    return (
      <SubNavButtonContain>
        <SubNavButton {...rest}>
          <SVGIcon icon={icon} iconStyle={theme} />
          <SubNavSpan>{name}</SubNavSpan>
        </SubNavButton>
      </SubNavButtonContain>
    );
  }
}
